import React, { useState} from 'react'

import './Header.scss'
import Hamburger from './Assets/hamburger.svg'
import Logo from './Assets/logo_white.svg'

import Nav from './Nav/Nav'

function Header({activeSound, toggleSound, targets, setClicked}) {

  const [navOpen, setNavOpen] = useState(false)

  const toggleNav = () => setNavOpen(prev => !prev)

  return (
    <>
      <header className='banzai_header'>
        <img src={Logo} alt='logo' className='banzai_header__logo' />
        <button onClick={toggleNav} className='banzai_header__hamburger' style={{ zIndex: navOpen && 2000  }}>
          <img src={Hamburger} alt='hamburger' className='' />
        </button>
      </header>
      {
        navOpen && <Nav navOpen={navOpen} toggleNav={toggleNav} activeSound={activeSound} toggleSound={toggleSound} targets={targets} setClicked={setClicked} />
      }
    </>
  )
}

export default Header